import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Crown, Check, ArrowLeft, CreditCard, CheckCircle } from 'lucide-react';

const SignUpPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    zip: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Sign up submitted:', formData);
    setSubmitted(true);
  };

  return (
    <main>
      {/* Hero */}
      <section className="bg-gradient-to-br from-emerald-600 to-emerald-700 text-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/comfort-loyalty" className="inline-flex items-center gap-2 text-emerald-200 hover:text-white mb-4" data-testid="back-loyalty">
            <ArrowLeft size={18} />
            Back to Comfort Loyalty
          </Link>
          <div className="flex items-center gap-3">
            <Crown className="w-10 h-10 text-yellow-400" />
            <h1 className="font-heading font-bold text-4xl">Join ComfortLoyalty Club</h1>
          </div>
        </div>
      </section>

      {/* Sign Up Form */}
      <section className="py-16 bg-stone-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Form */}
            <div className="lg:col-span-2">
              <div className="bg-white p-8 rounded-2xl shadow-sm">
                {submitted ? (
                  <div className="text-center py-12">
                    <CheckCircle className="w-16 h-16 text-emerald-600 mx-auto mb-4" />
                    <h2 className="font-heading font-bold text-2xl text-slate-900 mb-2">Welcome to the Club!</h2>
                    <p className="text-slate-600 mb-6">Your membership has been submitted. We'll contact you shortly to complete your enrollment.</p>
                    <Link to="/" className="btn-primary" data-testid="return-home">Return Home</Link>
                  </div>
                ) : (
                  <>
                    <h2 className="font-heading font-bold text-2xl text-slate-900 mb-6">Membership Information</h2>
                    <form onSubmit={handleSubmit} className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label className="form-label" htmlFor="firstName">First Name *</label>
                          <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} required className="form-input" data-testid="input-firstName" />
                        </div>
                        <div>
                          <label className="form-label" htmlFor="lastName">Last Name *</label>
                          <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} required className="form-input" data-testid="input-lastName" />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                          <label className="form-label" htmlFor="email">Email *</label>
                          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="form-input" data-testid="input-email" />
                        </div>
                        <div>
                          <label className="form-label" htmlFor="phone">Phone *</label>
                          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="form-input" data-testid="input-phone" />
                        </div>
                      </div>
                      <div>
                        <label className="form-label" htmlFor="address">Service Address *</label>
                        <input type="text" id="address" name="address" value={formData.address} onChange={handleChange} required className="form-input" data-testid="input-address" />
                      </div>
                      <div className="grid grid-cols-2 gap-6">
                        <div>
                          <label className="form-label" htmlFor="city">City *</label>
                          <input type="text" id="city" name="city" value={formData.city} onChange={handleChange} required className="form-input" data-testid="input-city" />
                        </div>
                        <div>
                          <label className="form-label" htmlFor="zip">ZIP Code *</label>
                          <input type="text" id="zip" name="zip" value={formData.zip} onChange={handleChange} required className="form-input" data-testid="input-zip" />
                        </div>
                      </div>
                      <button type="submit" className="btn-primary w-full flex items-center justify-center gap-2" data-testid="signup-submit">
                        <CreditCard size={18} />
                        Complete Enrollment - $16/month
                      </button>
                    </form>
                  </>
                )}
              </div>
            </div>

            {/* Summary */}
            <div>
              <div className="bg-emerald-600 text-white p-6 rounded-2xl sticky top-24">
                <h3 className="font-heading font-bold text-xl mb-4">Membership Summary</h3>
                <ul className="space-y-2 mb-6 text-sm">
                  {['2 Annual Tune-Ups', 'Priority Scheduling', '10% Repair Discount', 'No Overtime Charges'].map((item, i) => (
                    <li key={i} className="flex items-center gap-2">
                      <Check size={14} className="text-emerald-300" />
                      {item}
                    </li>
                  ))}
                </ul>
                <div className="border-t border-emerald-500 pt-4">
                  <div className="flex justify-between items-center">
                    <span>Monthly Total</span>
                    <span className="font-bold text-2xl">$16</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SignUpPage;
